import { PRICE_DISPLAY_QUANTITY_SET } from '../constants';
import { post } from '../Services/http';

export const setPriceDisplayQuantity = (quantity) => ({
  type: PRICE_DISPLAY_QUANTITY_SET,
  payload: {
    quantity,
  },
});
